import ChallengeRegisterInfo from './ChallengeRegisterInfo';

export default ChallengeRegisterInfo;
